/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_SubtitleInputs */



/**
* | output |
* | --- |
* | "The connector packages this deployment serves. A change applies to the next request on every instance." |
*
* @param {Partner_Connectors_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_subtitle = /** @type {((inputs?: Partner_Connectors_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Konnektor-Pakete, die dieses Deployment bereitstellt. Eine Änderung gilt ab der nächsten Anfrage auf jeder Instanz.")
	return /** @type {LocalizedString} */ ("The connector packages this deployment serves. A change applies to the next request on every instance.")
});